
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { BrandMenu } from '../TitleList';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { insertBrandEntry } from '../../Store/PHPSlice/Rack';
import BrandTable from '../MasterTables/BrandTbl/BrandTable';


const NewBrandEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        brandNm: '',
        userId: userdata?.ID
    });
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const [errors, setErrors] = useState({});
    const handleSubmit = (event) => {
        event.preventDefault();

        if (formData.brandNm === '') {
            alert("Enter the Brand Name.");
        }
        dispatch(insertBrandEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Rack Added");
                alert("Brand Added");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };






    return (
        <>
            {/* <Titlebar data={BrandMenu} /> */}
            <div style={{ margin: '1%' }}>
                <h2>Brand Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                <Grid item xs={12} md={6} >
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='brandNm' >Brand Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.brandNm}>
                                                <TextField
                                                    id='brandNm'
                                                    name='brandNm'
                                                    value={formData.brandNm}
                                                    onChange={handleInputChange}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}

                                                />
                                                {errors.brandNm && <FormHelperText style={errorStyles}>{errors.brandNm}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
                {/* <BrandTable /> */}

            </div>
        </>
    );
}

export default NewBrandEntry;
